import React from "react";
import Witstorms from "./components/Witstorms";
import ResearchPage from "./components/ResearchPage";

function App() {
  const [page, setPage] = React.useState("home");

  return (
    <div>
      {page === "home" ? (
        <Witstorms onNavigateToResearch={() => setPage("research")} />
      ) : (
        <ResearchPage onBack={() => setPage("home")} />
      )}
    </div>
  );
}

export default App;
